
/**
* 用工中心 用工结算明细
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-if="roleId === 2"
        :to="{ path: '/task/employmentStatementDesc' }"
        >用工中心</el-breadcrumb-item
      >
      <el-breadcrumb-item v-else :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用工结算明细</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :model="formInline" class="user-search" label-width="100px">
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="结算单ID：">
            <el-input
              size="small"
              v-model="formInline.detailId"
              placeholder="请输入结算单ID"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="证件号：">
            <el-input
              size="small"
              v-model="formInline.idNumber"
              placeholder="请输入证件号"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="服务费:">
            <el-input
              size="small"
              v-model="formInline.minServiceFee"
              placeholder="请输入"
              style="width: 47%"
            ></el-input>
            ~
            <el-input
              size="small"
              v-model="formInline.maxServiceFee"
              placeholder="请输入"
              style="width: 47%"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="结算单状态: ">
            <el-select
              size="small"
              v-model="formInline.status"
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option
                v-for="(val, index) in status_list"
                :label="val.label"
                :value="val.value"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="姓名:">
            <el-input
              size="small"
              v-model="formInline.name"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="编号信息:">
            <el-input
              size="small"
              v-model="formInline.settlementInfo"
              placeholder="请输入结算单编号"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="商户名称: ">
            <el-input
              size="small"
              v-model="formInline.merchantName"
              placeholder="请输入商户名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="任务名称:">
            <el-input
              size="small"
              v-model="formInline.taskName"
              placeholder="请输入任务名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="手机号:">
            <el-input
              size="small"
              v-model="formInline.mobile"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="5">
        <el-col :md="8" :xl="4">
          <el-form-item label="交易时间: ">
            <el-date-picker
              size="small"
              v-model="formInline.pay_date"
              type="daterange"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="8" :xl="4">
          <el-form-item label="创建时间: ">
            <el-date-picker
              size="small"
              v-model="formInline.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="6" :xl="4">
          <el-form-item label-width="30px">
            <el-button size="small" type="primary" @click="search"
              >搜索</el-button
            >
            <el-button size="small" @click="reset()">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button type="primary" size="small" @click="exportdata"
        >导出数据</el-button
      >
    </div>

    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column
        v-if="roleId === 2 || roleId === 4"
        fixed="left"
        prop="merchantName"
        label="商户名称"
        min-width="250"
      ></el-table-column>

      <el-table-column
        :fixed="roleId !== 2 ? 'left' : false"
        prop="detailId"
        label="结算单ID"
        min-width="120"
      ></el-table-column>
      <el-table-column label="收款信息" min-width="210">
        <template slot-scope="scope">
          <span>
            {{ scope.row.payeeName }}<br />
            {{ scope.row.payeeAccount }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="证件信息" min-width="210">
        <template slot-scope="scope">
          <span>
            {{ scope.row.identityDocumentTypeStr }}<br />
            {{ scope.row.identityDocumentNumber }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="结算单状态" min-width="120">
        <template slot-scope="scope">
          <span
            :style="{
              color: getStatusColor(scope.row.status),
            }"
            >{{ scope.row.statusStr }}</span
          >
        </template>
      </el-table-column>
      <el-table-column label="状态描述" min-width="120" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.detailsRemark }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="serviceFee"
        label="服务费（元）"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="preAmount"
        label="税前金额（元）"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="amountReceived"
        label="到账金额（元）"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="managementFeeRate"
        label="管理费率"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="managementFee"
        label="管理费（元）"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="managementFeeMode"
        label="管理费承担"
        show-overflow-tooltip
        min-width="120"
      >
        <template #default="scope">
          <span v-if="scope.row.managementFeeMode === 1">企业承担</span>
          <span v-else-if="scope.row.managementFeeMode === 2">个人承担</span>

          <span v-else-if="scope.row.managementFeeMode === 0"></span>
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="individualIncomeTaxMode"
        label="个税承担"
        show-overflow-tooltip
        min-width="120"
      >
        <template #default="scope">
          <span v-if="scope.row.individualIncomeTaxMode === 1">企业承担</span>
          <span v-else-if="scope.row.individualIncomeTaxMode === 2"
            >个人承担</span
          >

          <span v-else-if="scope.row.individualIncomeTaxMode === 0"></span>
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="individualIncomeTaxRate"
        label="个税税率"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="individualIncomeTax"
        label="个税（元）"
        min-width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="valueAddedTax"
        label="增值税（元）"
        min-width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="additionalTax"
        label="附加税（元）"
        min-width="120"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column label="收款备注" show-overflow-tooltip min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.paymentRemark }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="transSequenceIdn"
        label="流水号"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="taskName"
        label="任务名称"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="serviceCharge"
        label="计费范围"
        show-overflow-tooltip
        min-width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.minCharge }}元~{{ scope.row.maxCharge }}元</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="workload"
        label="工作量"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="rewardsPunishments"
        label="奖惩"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="更新时间"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
      <el-table-column
        prop="info"
        label="编号信息"
        show-overflow-tooltip
        min-width="120"
      >
      </el-table-column>
    </el-table>
    <div
      v-if="roleId === 2 || roleId === 3"
      style="background-color: #fff; padding: 15px; margin: 20px auto"
    >
      <el-row :gutter="20">
        <el-col :span="8"
          ><div>
            <div class="m-bott-15">
              <span>总服务费：</span
              ><span>{{
                formatNumber(currentPageSummary.totalServiceFee)
              }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="8"
          ><div>
            <div class="m-bott-15">
              <span>总管理费：</span
              ><span>{{
                formatNumber(currentPageSummary.totalManagementFee)
              }}</span>
            </div>
          </div>
        </el-col>
        <el-col :span="8"
          ><div>
            <div class="m-bott-15">
              <span>总支付：</span
              ><span>{{ formatNumber(currentPageSummary.totalPay) }}</span>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 分页组件 -->
    <Pagination
      v-bind:child-msg="pageparm"
      @callFather="callFather"
    ></Pagination>
    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="30%"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="部门名称" prop="deptName">
          <el-input
            size="small"
            v-model="editForm.deptName"
            auto-complete="off"
            placeholder="请输入部门名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门代码" prop="deptNo">
          <el-input
            size="small"
            v-model="editForm.deptNo"
            auto-complete="off"
            placeholder="请输入部门代码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  settlementsListdetails,
  exportsettlementsexcel,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      infos: {
        totalServiceFee: 0,
        totalManagementFee: 0,
        totalPay: 0,
      },
      // merchantName_list: [
      //   {
      //     label: JSON.parse(localStorage.getItem("user_info")).name,
      //     value: JSON.parse(localStorage.getItem("user_info")).name,
      //   },
      // ],
      status_list: [
        {
          label: "校验中",
          value: 1,
        },
        {
          label: "初验成功",
          value: 2,
        },
        {
          label: "验证失败",
          value: 3,
        },
        {
          label: "已取消",
          value: 4,
        },
        {
          label: "待结算",
          value: 5,
        },
        {
          label: "结算中",
          value: 6,
        },
        {
          label: "结算成功",
          value: 7,
        },
        {
          label: "结算失败",
          value: 8,
        },
        {
          label: "已退款",
          value: 9,
        },
        {
          label: "已退票",
          value: 10,
        },
        {
          label: "银行挂账",
          value: 11,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      editForm: {
        pay_date: [],
        date: [],
        positionId: "",
        taskName: "",
        positionState: "",
        token: localStorage.getItem("logintoken"),
      },
      // rules表单验证
      rules: {},
      formInline: {
        page: 1,
        pageSize: 10,
        detailId: "",
        batchNumber: "",
        status: "",
        merchantName: "",
        idNumber: "",
        taskName: "",
        name: "",
        minServiceFee: "",
        maxServiceFee: "",
        settlementInfo: "",
        mobile: "",
        pay_date: [],
        date: [],
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
      // 角色
      roleId: 0, //
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    let user = JSON.parse(localStorage.getItem("user_info"));
    this.roleId = user.roleId;
    this.getdata(this.formInline);
  },
  computed: {
    currentPageSummary() {
      const summary = this.listData.reduce(
        (acc, item) => {
          acc.totalServiceFee += Number(item.serviceFee || 0);
          acc.totalManagementFee += Number(item.managementFee || 0);
          return acc;
        },
        {
          totalServiceFee: 0,
          totalManagementFee: 0,
        }
      );

      // 更新 infos 对象
      this.infos.totalServiceFee = summary.totalServiceFee;
      this.infos.totalManagementFee = summary.totalManagementFee;
      this.infos.totalPay =
        summary.totalServiceFee + summary.totalManagementFee;

      return this.infos;
    },
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    getStatusColor(status) {
      // {
      //     label: "校验中",
      //     value: 1,
      //   },
      //   {
      //     label: "初验成功",
      //     value: 2,
      //   },
      //   {
      //     label: "验证失败",
      //     value: 3,
      //   },
      //   {
      //     label: "已取消",
      //     value: 4,
      //   },
      //   {
      //     label: "待结算",
      //     value: 5,
      //   },
      //   {
      //     label: "结算中",
      //     value: 6,
      //   },
      //   {
      //     label: "结算成功",
      //     value: 7,
      //   },
      //   {
      //     label: "结算失败",
      //     value: 8,
      //   },
      //   {
      //     label: "已退款",
      //     value: 9,
      //   },
      //   {
      //     label: "已退票",
      //     value: 10,
      //   },
      //   {
      //     label: "银行挂账",
      //     value: 11,
      //   },
      // 根据状态值返回对应的颜色
      switch (status) {
        case 1:
        case 5:
        case 6:
          return "#409EFF"; // 蓝色
        case 2:
        case 7:
          return "#67C23A"; // 绿色
        case 4:
          return "#909399"; // 灰色
        case 3:
        case 8:
        case 9:
        case 10:
        case 11:
          return "#F56C6C"; // 红色

        default:
          return "#303133"; // 默认黑色
      }
    },
    reset() {
      (this.formInline = {
        page: 1,
        pageSize: 10,
        detailId: "",
        batchNumber: "",
        status: "",
        merchantName: "",
        idNumber: "",
        taskName: "",
        name: "",
        minServiceFee: "",
        maxServiceFee: "",
        settlementInfo: "",
        mobile: "",
        pay_date: [],
        date: [],
      }),
        this.getdata(this.formInline);
    },
    exportdata() {
      const params = { ...this.formInline };

      // 处理日期格式
      params.transactionStartDate =
        params.pay_date && params.pay_date.length > 0 ? params.pay_date[0] : "";
      params.transactionEndDate =
        params.pay_date && params.pay_date.length > 1 ? params.pay_date[1] : "";
      params.createdStartDate =
        params.date && params.date.length > 0 ? params.date[0] : "";
      params.createdEndDate =
        params.date && params.date.length > 1 ? params.date[1] : "";

      // 清除不需要的字段
      delete params.pay_date;
      delete params.date;

      // 没页数据调大
      params.pageSize = 9999;

      exportsettlementsexcel(params).then((res) => {
        if (res.msg == "success") {
          window.open(res.data.downloadUrl);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    // 获取公司列表
    getdata(parameter) {
      this.loading = true;
      parameter.transactionStartDate =
        parameter.pay_date && parameter.pay_date.length > 0
          ? parameter.pay_date[0]
          : "";
      parameter.transactionEndDate =
        parameter.pay_date && parameter.pay_date.length > 1
          ? parameter.pay_date[1]
          : "";
      parameter.createdStartDate =
        parameter.date && parameter.date.length > 0 ? parameter.date[0] : "";
      parameter.createdEndDate =
        parameter.date && parameter.date.length > 1 ? parameter.date[1] : "";

      settlementsListdetails(parameter)
        .then((res) => {
          this.loading = false;
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.listData = res.data.items;
            // 分页赋值
            this.pageparm.page = res.data.page;
            this.pageparm.pageSize = res.data.pageSize;
            this.pageparm.total = res.data.totalCount;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.page;
      this.formInline.pageSize = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    //显示编辑界面
    handleEdit: function (index, row) {},
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          //  deptSave(this.editForm)
          //    .then(res => {
          //      this.editFormVisible = false
          //      this.loading = false
          //      if (res.success) {
          //        this.getdata(this.formInline)
          //        this.$message({
          //          type: 'success',
          //          message: '公司保存成功！'
          //        })
          //      } else {
          //        this.$message({
          //          type: 'info',
          //          message: res.msg
          //        })
          //      }
          //    })
          //    .catch(err => {
          //      this.editFormVisible = false
          //      this.loading = false
          //      this.$message.error('公司保存失败，请稍后再试！')
          //    })
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          //  deptDelete(row.deptId)
          //    .then(res => {
          //      if (res.success) {
          //        this.$message({
          //          type: 'success',
          //          message: '公司已删除!'
          //        })
          //        this.getdata(this.formInline)
          //      } else {
          //        this.$message({
          //          type: 'info',
          //          message: res.msg
          //        })
          //      }
          //    })
          //    .catch(err => {
          //      this.loading = false
          //      this.$message.error('公司删除失败，请稍后再试！')
          //    })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
    formatNumber(num) {
      return num ? num.toFixed(2) : "0.00";
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/task/employmentStatementDesc.vue